<template>
  <div class="underLease-group-dashboard-leaseOrders" v-loading="loading">
    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <el-radio-group class="mb16" v-model="statCycle" size="small" @input="handleStatCycleChange">
      <el-radio-button :label="1">昨日</el-radio-button>
      <el-radio-button :label="2">本周</el-radio-button>
      <el-radio-button :label="3">本月</el-radio-button>
    </el-radio-group>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 租赁中订单 -->
        <HorizontalCardStyle2
          :title="leaseOrderData.title"
          :dataDesc="leaseOrderData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="leaseOrderData.primaryDataList"
          :secondaryDataList="leaseOrderData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 到期未还车订单 -->
        <HorizontalCardStyle2
          :title="overdueNotReturnOrderData.title"
          :dataDesc="overdueNotReturnOrderData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="overdueNotReturnOrderData.primaryDataList"
          :secondaryDataList="overdueNotReturnOrderData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 续约订单 -->
        <HorizontalCardStyle1
          :title="renewalOrderData.title"
          :dataDesc="renewalOrderData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="renewalOrderData.primaryDataList"
          :secondaryDataList="renewalOrderData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <div class="module-title">数据分析</div>

    <el-row class="mb16">
      <el-col :span="24">
        <FiltersBox
          :filterList="orderChartFilter.filterList"
          :model.sync="orderChartFilter.model"
          @change="handleOrderChartFiltersChange"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 租赁中订单（折线图） -->
        <LineChartCard
          class="chart"
          :title="leaseOrderChartData.title"
          :tooltip="leaseOrderChartData.tooltip"
          :dataDesc="leaseOrderChartData.dataDesc"
          :dataUpdateTime="leaseOrderChartData.dataUpdateTime"
          :xAxis="leaseOrderChartData.xAxis"
          :yAxis="leaseOrderChartData.yAxis"
          :legendData="leaseOrderChartData.legendData"
          :seriesData="leaseOrderChartData.seriesData"
          :unit="leaseOrderChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 租赁中创建的关联订单（折线图） -->
        <LineChartCard
          class="chart"
          :title="leaseRelatedOrderChartData.title"
          :tooltip="leaseRelatedOrderChartData.tooltip"
          :dataDesc="leaseRelatedOrderChartData.dataDesc"
          :dataUpdateTime="leaseRelatedOrderChartData.dataUpdateTime"
          :xAxis="leaseRelatedOrderChartData.xAxis"
          :yAxis="leaseRelatedOrderChartData.yAxis"
          :legendData="leaseRelatedOrderChartData.legendData"
          :seriesData="leaseRelatedOrderChartData.seriesData"
          :unit="leaseRelatedOrderChartData.unit"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 续约订单（折线图） -->
        <LineChartCard
          class="chart"
          :title="renewalOrderChartData.title"
          :tooltip="renewalOrderChartData.tooltip"
          :dataDesc="renewalOrderChartData.dataDesc"
          :dataUpdateTime="renewalOrderChartData.dataUpdateTime"
          :xAxis="renewalOrderChartData.xAxis"
          :yAxis="renewalOrderChartData.yAxis"
          :legendData="renewalOrderChartData.legendData"
          :seriesData="renewalOrderChartData.seriesData"
          :unit="renewalOrderChartData.unit"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  getLeaseOrderInfo,
  getLeaseOrderNum,
} from '@/api/domain/underLease'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2.vue'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard/index.vue'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox/index.vue'
import { thisMonthT_1, thisWeekT_1, yesterday } from '@/bizComponents/Dashboard/utils/date'
import { getYAxisNumMax } from '@/bizComponents/Dashboard/utils/function'
import moment from 'moment'

export default {
  components: {
    FiltersBox,
    HorizontalCardStyle1,
    HorizontalCardStyle2,
    LineChartCard,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 统计周期(1:昨日 2:当周平均 3:当月平均)
      statCycle: 1,
      // 局部筛选
      orderChartFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 180,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
        ],
        model: {
          // 默认最近7天
          date: [
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000 - (7 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 租赁中订单
      leaseOrderData: {
        title: '租赁中订单',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 到期未还车订单
      overdueNotReturnOrderData: {
        title: '到期未还车订单',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 续约订单
      renewalOrderData: {
        title: '续约订单',
        dataDesc: 'T-1日数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 租赁中订单图表
      leaseOrderChartData: {
        title: '租赁中订单',
        tooltip: '统计周期内每日新增租赁中的个人订单与企业子订单数量',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
        },
        legendData: ['个人订单', '企业子订单'],
        seriesData: [],
      },
      // 租赁中创建的关联订单图表
      leaseRelatedOrderChartData: {
        title: '租赁中创建的关联订单',
        tooltip: '统计周期内每日新增的租中换车、更换租赁模式、续约订单数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
        },
        legendData: ['租中换车', '更换租赁模式', '续约'],
        seriesData: [],
      },
      // 续约订单图表
      renewalOrderChartData: {
        title: '续约订单',
        tooltip: '统计周期内每日新增的个人续约订单和企业续约子订单的订单数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
          },
          max: (value) => getYAxisNumMax(value, 50),
        },
        legendData: ['个人订单续约', '企业子订单续约'],
        seriesData: [],
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      const { date } = this.orderChartFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
        statCycle: this.statCycle,
        startDate,
        endDate,
      }
    },
    // 时间周期
    theOrderStart() {
      if (this.statCycle === 1) {
        return yesterday
      } else if (this.statCycle === 2) {
        return thisWeekT_1
      }
      return thisMonthT_1
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
    // 部门路由参数
    routerDeptId() {
      const selectedDeptId = this.globalFilter.model.deptId
      return selectedDeptId === this.rootDeptId ? '' : selectedDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.getLeaseOrderInfo(),
        this.getLeaseOrderNum(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleOrderChartFiltersChange() {
      this.loading = true
      this.getLeaseOrderNum().finally(() => {
        this.loading = false
      })
    },
    handleStatCycleChange() {
      this.loading = true
      this.getLeaseOrderInfo().finally(() => {
        this.loading = false
      })
    },
    // 跳转租赁中订单列表
    toUnderLeaseOrderList({ activeName, childActiveName }) {
      const query = {
        search: {
          deptId: this.routerDeptId,
          theOrderStart: this.theOrderStart,
        },
      }

      this.$router.push({
        path: '/underLease/underLeaseOrder',
        query: {
          // 一级tab
          activeName: activeName || '',
          // 二级tab
          childActiveName: childActiveName || '',
          query: JSON.stringify(query),
        },
      })
    },
    // 跳转订单续约
    toOrderRenewal({ tab }) {
      const query = {
        search: {
          deptId: this.routerDeptId,
          gmtCreate: this.theOrderStart,
        },
      }

      // tab
      if (typeof tab !== 'undefined') {
        query.tab = tab
      }

      this.$router.push({
        path: '/underLease/orderRenewal/list',
        query: {
          query: JSON.stringify(query),
        },
      })
    },
    // 获取租赁中订单信息
    async getLeaseOrderInfo() {
      const res = await getLeaseOrderInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        this.dataUpdateTime = data.updateTime || ''
        // 租赁中订单
        this.leaseOrderData.primaryDataList = [
          {
            label: '租赁中订单总数',
            value: data.totalOrderNum || 0,
            tooltip: '订单状态为“租赁中”的个人订单+企业子订单总数',
            // 跳转租赁中-租赁中订单列表-个人租赁订单
            clickCallback: () => this.toUnderLeaseOrderList({
              activeName: 'personal',
              childActiveName: '2',
            }),
          },
          {
            label: '新增租赁中订单数',
            value: data.leaseOrderNum || 0,
            tooltip: '统计周期内新增“租赁中”的个人订单+企业子订单数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.leaseOrderDayRadio,
                },
                {
                  name: '周同比',
                  value: data.leaseOrderWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-租赁中订单列表-个人租赁订单，订单状态变更为“租赁中”，订单创建时间为统计周期
            clickCallback: () => this.toUnderLeaseOrderList({
              activeName: 'personal',
              childActiveName: '21',
            }),
          },
        ]

        // 到期未还订单
        this.overdueNotReturnOrderData.primaryDataList = [
          {
            label: '到期未还车订单数',
            value: data.overdueNotReturnTotalNum || 0,
            tooltip: '订单状态为“租赁中”的个人订单+企业子订单超过计租/免租结束日但未还车订单总数',
            // 跳转租赁中-租赁中订单列表-个人租赁订单-到期未还车
            clickCallback: () => this.toUnderLeaseOrderList({
              activeName: 'personal',
              childActiveName: '22',
            }),
          },
          {
            label: '新增到期未还车订单数',
            value: data.overdueNotReturnNum || 0,
            tooltip: '统计周期内新增订单状态为“租赁中”的个人订单+企业子订单超过计租/免租结束日但未还车订单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.overdueNotReturnDayRadio,
                },
                {
                  name: '周同比',
                  value: data.overdueNotReturnWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-租赁中订单列表-个人租赁订单-到期未还车
            clickCallback: () => this.toUnderLeaseOrderList({
              activeName: 'personal',
              childActiveName: '22',
            }),
          },
        ]

        // 续约订单
        this.renewalOrderData.primaryDataList = [
          {
            label: '续约订单总数',
            value: data.renewalTotalNum || 0,
            tooltip: '租赁中续约订单总数',
            // 跳转租赁中-订单续约
            clickCallback: () => this.toOrderRenewal({
              tab: 'personal',
            }),
          },
        ]
        this.renewalOrderData.secondaryDataList = [
          {
            label: '新增续约订单数',
            value: data.renewalNum || 0,
            tooltip: '统计周期内新增续约订单总数（个人租赁订单、企业租赁子订单）',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.renewalNumDayRadio,
                },
                {
                  name: '周同比',
                  value: data.renewalNumWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-订单续约-个人续约订单，订单创建时间为统计周期
            clickCallback: () => this.toOrderRenewal({
              tab: 'personal',
            }),
          },
          {
            label: '个人订单续约率',
            value: ((data.rentRenewalRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '个人订单到期日在统计周期内已完成续约订单数/个人订单到期日在统计周期内履约中订单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.rentRenewalRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.rentRenewalRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-订单续约-个人续约订单
            clickCallback: () => this.toOrderRenewal({
              tab: 'personal',
            }),
          },
          {
            label: '企业子订单续约率',
            value: ((data.entRenewalRate || 0) * 100).toFixed(2),
            unit: '%',
            tooltip: '企业子订单到期日在统计周期内已完成续约订单数/企业订单到期日在统计周期内履约中的订单总数',
            ratioList: this.statCycle === 1
              ? [
                {
                  name: '日环比',
                  value: data.entRenewalRateDayRadio,
                },
                {
                  name: '周同比',
                  value: data.entRenewalRateWeekYoY,
                },
              ]
              : [],
            // 跳转租赁中-订单续约-企业续约子订单
            clickCallback: () => this.toOrderRenewal({
              tab: 'enterpriseSub',
            }),
          },
        ]
      }
    },
    // 获取租赁中订单数量图表
    async getLeaseOrderNum() {
      const res = await getLeaseOrderNum(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 租赁中订单
        this.leaseOrderChartData.dataUpdateTime = data[0]?.updateTime || ''
        this.leaseOrderChartData.xAxis.data = data.map((item) => item.ds) || []
        this.leaseOrderChartData.seriesData = [
          {
            name: '个人订单',
            data: data.map((item) => ([
              item.ds,
              item.rentOrderNum || 0,
              {
                dataTitle: this.leaseOrderChartData.title,
              },
            ])),
          },
          {
            name: '企业子订单',
            data: data.map((item) => ([
              item.ds,
              item.entOrderNum || 0,
              {
                dataTitle: this.leaseOrderChartData.title,
              },
            ])),
          },
        ]

        // 租赁中创建的关联订单
        this.leaseRelatedOrderChartData.dataUpdateTime = data[0]?.updateTime || ''
        this.leaseRelatedOrderChartData.xAxis.data = data.map((item) => item.ds) || []
        this.leaseRelatedOrderChartData.seriesData = [
          {
            name: '租中换车',
            data: data.map((item) => ([
              item.ds,
              item.changeCarNum || 0,
              {
                dataTitle: this.leaseRelatedOrderChartData.title,
              },
            ])),
          },
          {
            name: '更换租赁模式',
            data: data.map((item) => ([
              item.ds,
              item.changeModeNum || 0,
              {
                dataTitle: this.leaseRelatedOrderChartData.title,
              },
            ])),
          },
          {
            name: '续约',
            data: data.map((item) => ([
              item.ds,
              item.renewalNum || 0,
              {
                dataTitle: this.leaseRelatedOrderChartData.title,
              },
            ])),
          },
        ]

        // 续约订单
        this.renewalOrderChartData.dataUpdateTime = data[0]?.updateTime || ''
        this.renewalOrderChartData.xAxis.data = data.map((item) => item.ds) || []
        this.renewalOrderChartData.seriesData = [
          {
            name: '个人订单续约',
            data: data.map((item) => ([
              item.ds,
              item.rentRenewalNum || 0,
              {
                dataTitle: this.renewalOrderChartData.title,
              },
            ])),
          },
          {
            name: '企业子订单续约',
            data: data.map((item) => ([
              item.ds,
              item.entRenewalNum || 0,
              {
                dataTitle: this.renewalOrderChartData.title,
              },
            ])),
          },
        ]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
